import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type StandbyCardTemplatePermissionJoinedDb = {
  jointPaletteId: string;
  cardTemplateId: string;
  feeCharging: boolean;
  designCardPermission: boolean;
  overwriteCardTemplatePermission: boolean;
  saveNewCardTemplatePermission: boolean;
}
const initial: StandbyCardTemplatePermissionJoinedDb = {
  jointPaletteId: '',
  cardTemplateId: '',
  feeCharging: false,
  designCardPermission: false,
  overwriteCardTemplatePermission: false,
  saveNewCardTemplatePermission: false
};

export type StandbyCardTemplatePermissionJoinedDbHashType = {
  [key in string]: StandbyCardTemplatePermissionJoinedDb;
}

export type StandbyCardTemplatePermissionJoinedAddPayload = {
  id?: string;
} & StandbyCardTemplatePermissionJoinedDb;
export type StandbyCardTemplatePermissionJoinedUpdatePayload = {
  id: string;
} & { [P in keyof StandbyCardTemplatePermissionJoinedDb]?: StandbyCardTemplatePermissionJoinedDb[P] };

export type StandbyCardTemplatePermissionJoinedDbState = {
  standbyCardTemplatePermissionJoineds: StandbyCardTemplatePermissionJoinedDbHashType;
}

export const generateStandbyCardTemplatePermissionJoinedId = (): string => generateId('sctpj');
let initialState: StandbyCardTemplatePermissionJoinedDbState = { standbyCardTemplatePermissionJoineds: {} };
const key = 'standbyCardTemplatePermissionJoineds';

const standbyCardTemplatePermissionJoinedDbSlice = createSlice({
  name: 'standbyCardTemplatePermissionJoinedDb',
  initialState,
  reducers: {
    initializeStandbyCardTemplatePermissionJoineds(state: StandbyCardTemplatePermissionJoinedDbState) {
      state.standbyCardTemplatePermissionJoineds = {};
    },
    addStandbyCardTemplatePermissionJoined(state: StandbyCardTemplatePermissionJoinedDbState, action: PayloadAction<StandbyCardTemplatePermissionJoinedAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateStandbyCardTemplatePermissionJoinedId();
      state.standbyCardTemplatePermissionJoineds[id] = obj;
      saveData(key, id, obj);
    },
    updateStandbyCardTemplatePermissionJoined(state: StandbyCardTemplatePermissionJoinedDbState, action: PayloadAction<StandbyCardTemplatePermissionJoinedUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.standbyCardTemplatePermissionJoineds[id] === undefined) {
        console.log(`*** StandbyCardTemplatePermissionJoined not found: ${id}`);
      } else {
        const newData = { ...state.standbyCardTemplatePermissionJoineds[id], ...obj };
        state.standbyCardTemplatePermissionJoineds[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteStandbyCardTemplatePermissionJoined(state: StandbyCardTemplatePermissionJoinedDbState, action: PayloadAction<StandbyCardTemplatePermissionJoinedUpdatePayload>) {
      const id = action.payload.id;
      delete state.standbyCardTemplatePermissionJoineds[id];
      deleteData(key, id);
    },
    saveStandbyCardTemplatePermissionJoineds(state: StandbyCardTemplatePermissionJoinedDbState) {
      saveAllData(key, state.standbyCardTemplatePermissionJoineds);
    },
    signUpStandbyCardTemplatePermissionJoineds(state: StandbyCardTemplatePermissionJoinedDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.standbyCardTemplatePermissionJoineds, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: StandbyCardTemplatePermissionJoinedDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.standbyCardTemplatePermissionJoineds = updatedValues;
      if (changed) saveAllData(key, state.standbyCardTemplatePermissionJoineds);
    })
  }
})

export const { initializeStandbyCardTemplatePermissionJoineds, addStandbyCardTemplatePermissionJoined, updateStandbyCardTemplatePermissionJoined, deleteStandbyCardTemplatePermissionJoined, saveStandbyCardTemplatePermissionJoineds, signUpStandbyCardTemplatePermissionJoineds } = standbyCardTemplatePermissionJoinedDbSlice.actions;
export default standbyCardTemplatePermissionJoinedDbSlice.reducer;
